import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from 'segments/api/baseApi';

import { authSlice } from 'features/auth';
import { bookingWaitSlice } from 'features/bookingWait';
import { coachesSlice } from 'features/coaches';
import { coachesBookingSlice } from 'features/coachesBooking';
import { configSlice } from 'features/config/store/configSlice';
import { courtsSlice } from 'features/courts';
import { courtsBookingSlice } from 'features/courtsBooking';
import { groupsSlice } from 'features/groups';
import { modalsSlice } from 'features/modals';
import { productsSlice } from 'features/products';
import { userSlice } from 'features/user';
import { usersSlice } from 'features/users';

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [authSlice.name]: authSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [usersSlice.name]: usersSlice.reducer,
  [courtsSlice.name]: courtsSlice.reducer,
  [coachesSlice.name]: coachesSlice.reducer,
  [productsSlice.name]: productsSlice.reducer,
  [configSlice.name]: configSlice.reducer,
  [courtsBookingSlice.name]: courtsBookingSlice.reducer,
  [coachesBookingSlice.name]: coachesBookingSlice.reducer,
  [groupsSlice.name]: groupsSlice.reducer,
  [modalsSlice.name]: modalsSlice.reducer,
  [bookingWaitSlice.name]: bookingWaitSlice.reducer
});
